// Purpose: Present the shared event visibility setting on both event administration pages.
// Features: Accessible public/private selector and consistent discovery/access messaging.
// Dependencies: React and the containing page's form save lifecycle.
// Important behavior: Changes remain in the parent form until saved; private links remain accessible.

import React from "react";

const EventVisibilityControl = ({ publicEvent, onChange, disabled = false }) => (
  <div className="border rounded p-3">
    <label className="form-label fw-bold" htmlFor="event-visibility">Event Visibility</label>
    <select
      id="event-visibility"
      className="form-select"
      value={publicEvent ? "public" : "private"}
      disabled={disabled}
      aria-describedby="event-visibility-help"
      onChange={(event) => onChange(event.target.value === "public")}
    >
      <option value="public">Public — discoverable</option>
      <option value="private">Private — unlisted</option>
    </select>
    <div id="event-visibility-help" className="form-text">
      <p className="mb-2">Public events appear in LGV event search and may be indexed by search engines. Public event pages and eligible content from active Power Ups are included in XML sitemaps.</p>
      <p className="mb-2">Private events are hidden from LGV event search and XML sitemaps, and ask search engines not to index their pages. Existing search results may take time to disappear.</p>
      <p className="mb-0">Anyone with a direct link or QR code can still open a private event. This is not password protection. Voting, sign-in, payment, and manager permissions still apply. Save this form to apply the same setting on both admin pages.</p>
    </div>
  </div>
);

export default EventVisibilityControl;
